import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import MKAvatar from "components/MKAvatar";

import { creditTransactionCreate } from "actions/transactionActions";

function CreditCard({ image, title, client, amountToPay, orderId, action }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const creditTransaction = useSelector((state) => state.creditTransaction);
  const { transactionCredit, success, error, loading } = creditTransaction;
  console.log("🚀 ~ file: index.js:29 ~ CreditCard ~ error:", error);
  console.log("🚀 ~ file: index.js:30 ~ CreditCard ~ success:", success);
  console.log(
    "🚀 ~ file: index.js:32 ~ CreditCard ~ transactionCredit:",
    transactionCredit
  );

  useEffect(() => {
    if (success) {
      alert("Your Somosure agent will contact you to process your financing");
      console.log(
        "🚀 ~ file: index.js:20 ~ handleInitiateCredit ~ financing:",
        success
      );
      navigate("/dashboard");
    } else {
      // alert("Request Not Successful, Try again!");
      console.log(
        "🚀 ~ file: index.js:20 ~ handleInitiateCredit ~ financing error:",
        error
      );
    }
  }, [success, error]);

  const handleInitiateCredit = () => {
    console.log(
      "🚀 ~ file: index.js:20 ~ handleInitiateCredit ~ financing: started"
    );
    dispatch(creditTransactionCreate({ client: client?._id, order: orderId }));
  };

  return (
    <Card sx={{ pb: 5, px: 5 }}>
      <MKBox position="relative" borderRadius="lg" mx={22} mt={-3}>
        <MKBox
          component="img"
          src={image}
          alt={title}
          borderRadius="lg"
          width="100%"
          position="relative"
          zIndex={1}
        />
        <MKBox
          borderRadius="lg"
          shadow="md"
          width="100%"
          height="100%"
          position="absolute"
          left={0}
          top={0}
          sx={{
            backgroundImage: `url(${image})`,
            transform: "scale(0.94)",
            filter: "blur(12px)",
            backgroundSize: "cover",
          }}
        />
      </MKBox>
      <MKBox p={3} mt={-1} textAlign="center">
        <MKTypography
          display="inline"
          variant="h5"
          textTransform="capitalize"
          fontWeight="regular"
        >
          {title}
        </MKTypography>
        <MKBox my={5}>
          {/* <MKTypography variant="body2" component="p" color="text">
            {description}
          </MKTypography> */}
          <MKBox display="flex" p={1}>
            <MKBox maxWidth={300}>
              <MKAvatar
                src={client?.profile_image}
                name={client?.name}
                size="md"
              />
            </MKBox>
            <MKBox display="flex" flexDirection="column">
              <MKTypography
                component="span"
                variant="button"
                color="dark"
                opacity={0.8}
                ml={2}
                fontWeight="bold"
                fontSize="medium"
              >
                {client?.name}
              </MKTypography>
              <MKTypography
                component="span"
                variant="button"
                color="dark"
                opacity={0.8}
                ml={2}
                fontWeight="regular"
              >
                Policy Holder
              </MKTypography>
            </MKBox>
          </MKBox>
          <MKBox display="flex" color="dark" p={1}>
            <MKTypography variant="button" color="dark">
              {/* <i className="fas fa-map-marker-alt" /> */}
              Policy Holder Phone:
            </MKTypography>
            <MKTypography
              component="span"
              variant="button"
              color="dark"
              opacity={0.8}
              ml={2}
              fontWeight="bold"
              fontSize="medium"
            >
              {client?.phone}
            </MKTypography>
          </MKBox>
          <MKBox display="flex" color="dark" p={1}>
            <MKTypography variant="button" color="dark">
              {/* <i className="fas fa-map-marker-alt" /> */}
              Total Amount:
            </MKTypography>
            <MKTypography
              component="span"
              variant="button"
              color="dark"
              opacity={0.8}
              ml={2}
              fontWeight="bold"
              fontSize="medium"
            >
              Ksh. {amountToPay}
            </MKTypography>
          </MKBox>
        </MKBox>
        {/* {action.type === "external" ? (
          <MKButton
            component={MuiLink}
            href={action.route}
            target="_blank"
            rel="noreferrer"
            variant="gradient"
            size="large"
            color={action.color ? action.color : "dark"}
          >
            {action.label}
          </MKButton>
        ) : ( */}
        {/* <MKButton
          variant="gradient"
          size="large"
          color={action.color ? action.color : "dark"}
          onClick={handleInitiateCredit}
        >
          {action.label}
        </MKButton> */}
        <LoadingButton
          variant="contained"
          size="large"
          color="primary"
          onClick={handleInitiateCredit}
          loading={loading}
          loadingPosition="end"
          endIcon={<SendIcon color="white" />}
        >
          <MKTypography color="white">{action.label}</MKTypography>
        </LoadingButton>
        {/* )} */}
      </MKBox>
    </Card>
  );
}

// Typechecking props for the CreditCard
CreditCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default CreditCard;
